import { render } from "./CreateBankView.vue?vue&type=template&id=7a338418&scoped=true"
import script from "./CreateBankView.vue?vue&type=script&lang=js"
export * from "./CreateBankView.vue?vue&type=script&lang=js"

import "./CreateBankView.vue?vue&type=style&index=0&id=7a338418&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a338418"]])

export default __exports__